import { useDispatch } from 'react-redux'
import { gotoLogIn } from '../../redux/actions/AuthActions'
import { LogIn, Root, Subtitle, Title } from './FooterBanner.styles.js'
import { Button, Show } from './landing.styles.js'

const FooterBanner = ({ bg, bgMobile }) => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }

  return (
    <Root>
      <Title>Start Designing Your Dream Room Today</Title>
      <Subtitle>Join millions using DecorMatters to visualize layouts, test furniture, and design their dream space.</Subtitle>
      <Button onClick={openLogin}>Start Designing Now</Button>
      <Show on="mobile">
        <Subtitle>
          Already registered? <LogIn onClick={openLogin}>Log In</LogIn>
        </Subtitle>
      </Show>
    </Root>
  )
}

export default FooterBanner
